import { platformBrowser } from '@angular/platform-browser';

// Standalone (local development) entry. Inside Rider_Web this file is not used: the host loads the
// remote through the federation entry (federation.config.mjs -> WalletRemoteEntryModule). zone.js
// comes from the build's `polyfills`, not an import here, so the host's single copy is the one used.
void import('./app/app-module').then(({ AppModule }) => {
  platformBrowser()
    .bootstrapModule(AppModule, {})
    .catch((err) => console.error(err));
});
